/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Send_Reset_LinkInputs */

const en_common_sign_send_reset_link = /** @type {(inputs: Common_Sign_Send_Reset_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send reset link`)
};

const zh_common_sign_send_reset_link = /** @type {(inputs: Common_Sign_Send_Reset_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送重置链接`)
};

/**
* | output |
* | --- |
* | "Send reset link" |
*
* @param {Common_Sign_Send_Reset_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_send_reset_link = /** @type {((inputs?: Common_Sign_Send_Reset_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Send_Reset_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_send_reset_link(inputs)
	return zh_common_sign_send_reset_link(inputs)
});
export { common_sign_send_reset_link as "common.sign.send_reset_link" }